import { useState, useCallback } from 'react'
import { Toast } from '../types/toast'

type ToastColor = 'success' | 'danger' | 'warning' | 'primary'

type UseToastNotificationsReturn = {
	toasts: Toast[],
	addToast: ( title: string, color?: ToastColor ) => void,
	removeToast: ( toast: Toast ) => void,
}

/**
 * Custom hook for managing toast notifications
 * @returns Object containing toasts array and functions to add/remove toasts
 */
export const useToastNotifications = (): UseToastNotificationsReturn => {
	const [ toasts, setToasts ] = useState<Toast[]>( [] )

	const addToast = useCallback( ( title: string, color: ToastColor = 'success' ) => {
		const newToast: Toast = {
			id: `toast-${Date.now()}`,
			title,
			color,
		}
		setToasts( ( prevToasts ) => [ ...prevToasts, newToast ] )
	}, [] )

	const removeToast = useCallback( ( removedToast: Toast ) => {
		setToasts( ( prevToasts ) => prevToasts.filter( ( toast ) => toast.id !== removedToast.id ) )
	}, [] )

	return {
		toasts,
		addToast,
		removeToast,
	}
}
